import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }
const _hoisted_2 = {
  class: "grid grid-cols-2 gap-6",
  style: {"grid-template-columns":"auto min-content"}
}
const _hoisted_3 = { class: "pb-3 pt-10" }
const _hoisted_4 = { class: "relative items-center py-4" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "error-message text-sm text-error"
}
const _hoisted_7 = { class: "relative items-center py-4" }
const _hoisted_8 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_location_selector = _resolveComponent("map-location-selector")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "is-displayed": _ctx.isCreateModalOpened,
    "is-select-modal": true,
    "no-padding": true,
    title: "Create asset",
    onToggleModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      (_ctx.isMapLocationModalOpened)
        ? (_openBlock(), _createBlock(_component_map_location_selector, {
            key: 0,
            "coordinates-prop": {
        lat: _ctx.deviceAssignment.assignmentRequest.latitude,
        lng: _ctx.deviceAssignment.assignmentRequest.longitude,
      },
            "is-map-location-modal-opened": _ctx.isMapLocationModalOpened,
            onToggleModal: _ctx.toggleMapLocationModal,
            onGetCoordinates: _ctx.getMarkerCoordinates
          }, null, 8, ["coordinates-prop", "is-map-location-modal-opened", "onToggleModal", "onGetCoordinates"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_form_wrapper, { "is-form-in-modal": _ctx.isFormInModal }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createVNode(_component_form_divider, null, {
                default: _withCtx(() => [
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.deviceAssignment.assignmentRequest.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deviceAssignment.assignmentRequest.name) = $event)),
                    errorMessage: 
                _ctx.v$?.deviceAssignment?.assignmentRequest['name']?.$errors[0]
                  ?.$message
              ,
                    isError: _ctx.v$?.deviceAssignment?.assignmentRequest['name']?.$error,
                    required: true,
                    label: "Name",
                    placeholder: "Enter device name..."
                  }, null, 8, ["modelValue", "errorMessage", "isError"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_input_field, {
                        modelValue: _ctx.deviceAssignment.assignmentRequest.latitude,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deviceAssignment.assignmentRequest.latitude) = $event)),
                        label: "Latitude"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_input_field, {
                        modelValue: _ctx.deviceAssignment.assignmentRequest.longitude,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deviceAssignment.assignmentRequest.longitude) = $event)),
                        label: "Longitude"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_the_button, {
                        icon: ['fas', 'earth-europe'],
                        "button-type": "primaryButton",
                        type: "button",
                        onExecuteMethod: _ctx.toggleMapLocationModal
                      }, null, 8, ["onExecuteMethod"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Group", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.isApplicationListLoading)
                        ? (_openBlock(), _createBlock(_component_small_loader, {
                            key: 0,
                            height: "h-8",
                            width: "w-8"
                          }))
                        : (_openBlock(), _createBlock(_component_v_select, {
                            key: 1,
                            modelValue: _ctx.deviceAssignment.assignmentRequest.applicationId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deviceAssignment.assignmentRequest.applicationId) = $event)),
                            class: _normalizeClass(`mt-1 w-full border ${
                    _ctx.v$.deviceAssignment?.assignmentRequest['applicationId']
                      ?.$error
                      ? 'rounded-md border-error'
                      : 'border-none'
                  }`),
                            options: _ctx.applications.items,
                            reduce: (spot) => spot.id,
                            label: "name",
                            clearable: false
                          }, null, 8, ["modelValue", "class", "options", "reduce"]))
                    ]),
                    (
                  _ctx.v$.deviceAssignment?.assignmentRequest['applicationId']
                    ?.$error
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.v$?.deviceAssignment?.assignmentRequest["applicationId"]
                    ?.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Device type", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.isDeviceTypeListLoading)
                        ? (_openBlock(), _createBlock(_component_small_loader, {
                            key: 0,
                            height: "h-8",
                            width: "w-8"
                          }))
                        : (_openBlock(), _createBlock(_component_v_select, {
                            key: 1,
                            modelValue: _ctx.deviceAssignment.deviceRequest!.deviceTypeId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deviceAssignment.deviceRequest!.deviceTypeId) = $event)),
                            class: _normalizeClass(`mt-1 w-full`),
                            options: _ctx.deviceTypes,
                            reduce: (spot) => spot.id,
                            label: "name",
                            clearable: false
                          }, null, 8, ["modelValue", "options", "reduce"]))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
            ], 32)
          ]),
          _: 1
        }, 8, ["is-form-in-modal"])
      ])
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}